// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('PaymentMadeCustomization/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('PaymentMadeCustomization/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/InvoicePreviewCustomization/GetPaymentsCustomization', { params })
    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data,
    }
})

export const PaymentMadeCustomizationSlice = createSlice({
    name: 'PaymentMadeCustomization',
    initialState: {
        data: {},
        params: {},
        loadingState: { getData: false }
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default PaymentMadeCustomizationSlice.reducer
